var nurseslounge_myDashboard_my_float_pool = {
    init: function ($params) {
        console.log("okokok");
    }
};
